module.exports = __webpack_public_path__ + "img/04-competition-pricing.3cfe04e4.png";